import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { DashboardService } from 'src/app/shared/services/dashboard.service';
import { RoleManagementService } from 'src/app/shared/services/role-management.service';

@Component({
  selector: 'app-notification-dialog',
  templateUrl: './notification-dialog.component.html',
  styleUrls: ['./notification-dialog.component.scss']
})
export class NotificationDialogComponent implements OnInit {
  notification: any;

  constructor(private _dashboardService: DashboardService,
    private router: Router,
    public dialogRef: MatDialogRef<NotificationDialogComponent>,
    public snackBar: MatSnackBar,
    private roleManagementService: RoleManagementService,
  ) { }

  ngOnInit(): void {
    this.NotificationList();
  }
  // Notification List
  NotificationList() {
    this._dashboardService.NotificationList().subscribe(
      (resp: any) => {
        this.notification = resp.data;
      })
  }
  // Notification Navigation
  handleNotificationClick(test: any) {
    this.roleManagementService.checkUserRole().subscribe(isRoleActive => {
      if (isRoleActive) {
        if (test.module_name == 'Add job') {
          this.UpdateNotification(test.id)
          this.dialogRef.close();
          this.router.navigate(['/admin/jobs']);
        }
        else if (test.module_name == 'User Support') {
          this.UpdateNotification(test.id)
          this.dialogRef.close();
          this.router.navigate(['/admin/support']);
        }
      }
    })
  }
  // Update Notification Status
  UpdateNotification(id: any) {
    this.roleManagementService.checkUserRole().subscribe(isRoleActive => {
      if (isRoleActive) {
        const formData = new FormData();
        formData.append('status', '1');
        this._dashboardService.UpdateNotification(id, formData).subscribe({
          next: (res) => {
            this.dialogRef.close();
          },
          error: (err: any) => {
            this.snackBar.open(err, 'Dismiss', {
              duration: 3000
            });
          }
        });
      }
    })
  }
}
